import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Field, reduxForm } from 'redux-form';
import { Form, Modal, Message } from 'semantic-ui-react';

// Actions
// @ts-ignore
import { createGroup, editGroup } from 'services/groups/actions';

// Components
// @ts-ignore
import SubmittingSection from 'components/SubmissionSection';

// @ts-ignore
import PersonTypeahead from 'components/PersonTypeahead';
// @ts-ignore
import EntityTypeahead from 'components/EntityTypeahead';
import EntityTypesExistGate from 'components/EntityTypesExistGate';

// Form
// @ts-ignore
import { normalizers, validators, RenderColorPicker, RenderField } from 'forms';

// Selectors
// @ts-ignore
import { makeSelectEntityTypeFirstDepthValue } from 'services/entityTypes/selectors';
// @ts-ignore
import { selectCurrentSeasonIsComplete } from 'services/currentSeasonId/selectors';
// @ts-ignore
import { selectInitialValues } from './selectors';

// Normalizers
const { toNull, toArrayIfFalsy } = normalizers;

// Validators
const { isRequired, hasLength } = validators;

// Constants
const NAMESPACE = ['GROUP_CREATE', 'GROUP_UPDATE'];

interface Props {
    groupId?: number;
    entityTypeId: number;
    handleSubmit: Function;
    onClose: Function;
    createGroup: Function;
    editGroup: Function;
    disabled: boolean;
    error?: string;
}

class GroupForm extends React.PureComponent<Props> {
    handleSubmit = (values: Record<string, any>): void => {
        const { groupId, ...props } = this.props;

        if (groupId) {
            props.editGroup(groupId, values);
        } else {
            props.createGroup(values);
        }
    };

    render(): React.ReactElement {
        const { entityTypeId, disabled, error, handleSubmit, onClose } =
            this.props;

        return (
            <React.Fragment>
                <Modal.Header>Group Details</Modal.Header>
                <Modal.Content className="constrain-width">
                    <Form
                        onSubmit={handleSubmit(this.handleSubmit)}
                        autoComplete="off"
                    >
                        <Field
                            name="name"
                            component={RenderField as any}
                            label="Name (required)"
                            type="text"
                            placeholder="Enter name"
                            validate={isRequired}
                            disabled={disabled}
                        />
                        <PersonTypeahead
                            name="personIds"
                            label="People (optional)"
                            placeholder="Add people"
                            disabled={disabled}
                            multiple
                            type="select-multiple"
                            normalize={toArrayIfFalsy}
                        />
                        <EntityTypesExistGate>
                            <EntityTypeahead
                                name="entityIds"
                                validate={hasLength}
                                entityTypeId={entityTypeId}
                                multiple
                                type="select-multiple"
                                normalize={toArrayIfFalsy}
                                ignoreCurrentEntityId
                                disabled={disabled}
                            />
                        </EntityTypesExistGate>
                        <Field
                            name="color"
                            component={RenderColorPicker}
                            label="Colour (optional)"
                            placeholder="Add colour"
                            type="text"
                            normalize={toNull}
                            disabled={disabled}
                        />
                        {error && <Message negative>{error}</Message>}
                        <SubmittingSection
                            submittingButtonParam={{
                                disabled,
                                namespace: NAMESPACE
                            }}
                            normalCancelButtonParam={{
                                onClose: (): void => {
                                    onClose();
                                }
                            }}
                        />
                    </Form>
                </Modal.Content>
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    initialValues: selectInitialValues,
    entityTypeId: makeSelectEntityTypeFirstDepthValue('id'),
    disabled: selectCurrentSeasonIsComplete
});

export default connect(mapStateToProps, { createGroup, editGroup })(
    reduxForm<any, any>({
        form: 'groupForm'
    })(GroupForm)
);
